import moment from 'moment';

moment.locale('pl');

export const SYSTEM_DATE = 'YYYY-MM-DD';
export const FORMAT_DATE = 'DD.MM.YYYY';
export const FORMAT_DATETIME = 'DD.MM.YYYY HH:mm';
export const FORMAT_DATETIME_SECONDS = 'DD.MM.YYYY HH:mm:ss';
export const FORMAT_TIMESTAMP = 'x';

export function createPeriod(startDate, numberOfDays) {

  if (!(startDate instanceof moment)) {
    startDate = dateFromTimestamp(startDate);
  }

  let period = [
    startDate,
  ];

  for (let i = 1; i < numberOfDays; i++) {
    period.push(startDate.clone().add(i, 'd'));
  }

  return period;
}

export function date(date, format = null) {
  return moment(date, format);
}

export function dateFromTimestamp(timestamp) {
  return moment(Number(timestamp));
}

export function addDay(date, days = 1) {
  return moment(date).add(days, 'd');
}

export function dateFormatter(date, format = FORMAT_DATETIME) {
  return moment(date).format(format);
}

export function dayReadable(date) {
  return dateFormatter(date, 'dddd');
}

export function createDateTime(date, time) {
  const dateObject = dateFromTimestamp(date);

  const [hour, minute] = time.split(':');

  dateObject.hour(hour);
  dateObject.minute(minute);
  dateObject.second(0);

  return dateObject;
}

export function createTimestampFromDateAndTime(date, time) {
  return Number(createDateTime(date, time).format(FORMAT_TIMESTAMP));
}

export function humanizeDuration(date) {
  return moment.duration(date).humanize(true);
}
